import { createRoute } from "@tanstack/react-router";
import { VersionPipelinePanel } from "@/components/case/version-pipeline-panel";
import { versionLayoutRoute } from "./version-layout-route";

export const versionPipelineRoute = createRoute({
  getParentRoute: () => versionLayoutRoute,
  path: "/pipeline",
  component: VersionPipelinePage,
});

function VersionPipelinePage() {
  const { caseId, versionId } = versionPipelineRoute.useParams();
  return <VersionPipelinePanel caseId={caseId} versionId={versionId} />;
}
